var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Calendar',{attrs:{"mode":"month","week-timeline":_vm.venueFormattedSchedule,"size":_vm.size,"slots":_vm.initialSlots,"start-date":_vm.startDate,"space-ids":_vm.spaceIds,"spaces-calendar-data":_vm.spacesCalendarData}})}
var staticRenderFns = []

export { render, staticRenderFns }